import React from 'react';
import { Nullable } from 'src/types/nullable.type';
import { useRefCallback } from 'src/utils/react/ref-callback.hook';

export type ScrollDirection = 'up' | 'down';

export function useScrollDirection(
  element: Nullable<HTMLElement>,
  onScrollDirectionChange: (direction: ScrollDirection) => void
) {
  const onScrollDirectionChangeCallback = useRefCallback(onScrollDirectionChange, [onScrollDirectionChange]);

  React.useEffect(() => {
    if (!element) {
      return;
    }
    let lastScrollTop = 0;
    const handleScroll = () => {
      const scrollTop = element.scrollTop;
      if (scrollTop > lastScrollTop) {
        onScrollDirectionChangeCallback('down');
      } else {
        onScrollDirectionChangeCallback('up');
      }
      lastScrollTop = scrollTop;
    };

    element.addEventListener('scroll', handleScroll);
    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [element, onScrollDirectionChangeCallback]);
}
